/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Buy with - custom add to cart on same product
 */

var buywith = document.querySelector('[data-buywith]')

if (buywith) {
    var buy = buywith.querySelectorAll('[data-buy]')

    buy.forEach(item => {
        var form = item.querySelector('form')
        var submit = item.querySelector('button[type="submit"]')

        form.addEventListener('submit', (e) => {
            e.preventDefault()

            submit.setAttribute('disabled', 'disabled')

            var data = new FormData(form)
            var id = data.get('id')
            var quantity = data.get('quantity')

            document.dispatchEvent(new CustomEvent('theme:loading:start'))

            fetch(window.routes.cartAddUrl + '.js', {
                body: JSON.stringify({ id, quantity }),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
            }).then(function (response) {
                document.dispatchEvent(new CustomEvent('theme:loading:end'))

                if (response.ok) {
                    submit.removeAttribute('disabled')
                    if (modal) {
                        modal.classList.remove('is-open')
                    }
                    form.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            quantity: parseInt(quantity)
                        }
                    }))
                } else {
                    response.json().then(function (content) {
                        var error = document.createElement('span')
                        error.className = 'ProductForm__Error Alert Alert--error'
                        error.innerHTML = content['description']
                        submit.removeAttribute('disabled')
                        submit.insertAdjacentElement('afterend', error)

                        setTimeout(function () {
                            error.remove()
                        }, 2500)
                    })
                }

            })
        })



        /**
         * Modal
         */

        var modalTrigger = item.querySelector('[data-modal-trigger]')
        var modal = item.querySelector('[data-modal]')

        if (modalTrigger && modal) {
            var close = modal.querySelector('[data-modal-close]')
            var inner = modal.querySelector('[data-modal-inner]')

            modalTrigger.addEventListener('click', function (e) {
                modal.classList.add('is-open')
            })

            document.addEventListener('click', function (e) {
                if (!inner.contains(e.target) && e.target != modalTrigger) {
                    modal.classList.remove('is-open')
                }
            })

            if (close) {
                close.addEventListener('click', function (e) {
                    modal.classList.remove('is-open')
                })
            }
        }

    })
}

$('.readmore').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
});

$('.readless').click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
});

if ((location.pathname.includes('/collections/farvevaelger-original-linoliemaling') ?? location.pathname.includes('/collections/farvevaelger-vaegmaling') ?? location.pathname.includes('/collections/farvevaelger-vaegmaling-ekstra') ?? location.pathname.includes('/collections/farvevaelger-linoliepasta') ?? location.pathname.includes('/collections/farvevaelger-naturmaling-linoliemaling') ?? location.pathname.includes('/collections/farvevaelger - beate')) && !location.search.includes('filter.p.m.color.main_product=1')) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filter.p.m.color.main_product=1';
    window.history.pushState({ path: newurl }, '', newurl);
    location.reload();
}
